import { useQuery } from '@tanstack/react-query';

import { taxReturnService } from '../services/taxReturn.service';

export const useTaxReturn = (id: string) => {
  return useQuery({
    queryKey: ['tax-return', id],
    queryFn: () => taxReturnService.getTaxReturn(id)
  });
};
